import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

export const ActionMenuDownload = ({ ...props }) => {
  return <i className="fas fa-download mx-1 my-1 awp-img-btn" title="Download" onClick={props.onClick} />;
};

export const ActionMenuEdit = ({ ...props }) => {
  return <i className="fas fa-edit mx-1 my-1 awp-img-btn" title="Edit" onClick={props.onClick} />;
};
export const ActionMenuView = ({ ...props }) => {
  return <i className="fas fa-eye mx-1 my-1 awp-img-btn" title="View" onClick={props.onClick} />;
};
export const ActionMenuDelete = ({ ...props }) => {
  return <i className="fas fa-trash mx-1 my-1 awp-img-btn" title="Delete" onClick={props.onClick} />;
};
export const ActionMenuLinkEdit = ({ ...props }) => {
  return (
    <Link to={props.link} state={{ id: props.linkId, stateMode: props.stateMode }} style={{ color: 'black' }}>
      <i className="fas fa-edit mx-1 my-1 awp-img-btn" title="Edit" />
    </Link>
  );
};
export const ActionMenuLinkView = ({ ...props }) => {
  return (
    <Link to={props.link} state={{ id: props.linkId, stateMode: props.stateMode }} style={{ color: 'black' }}>
      <i className="fas fa-eye mx-1 my-1 awp-img-btn" title="View" />
    </Link>
  );
};
